import { callAPI } from "../../network/networkConnection";
import { NetworkConfiguration } from "../../network/networkConfriguation";

/**
 * Admin Alibaba Import Service
 * Handles admin-specific Alibaba product import operations
 */
class AlibabaAdminService {
  /**
   * Import selected Alibaba products as drafts (status=6)
   * @param {Array} products - Array of Alibaba product objects
   * @returns {Promise} API response
   */
  static importProductsAsDrafts(products) {
    return new Promise((resolve, reject) => {
      callAPI(
        process.env.REACT_APP_APIUrl + NetworkConfiguration.IMPORT_ALIBABA_ADMIN,
        "POST",
        { "Content-Type": "application/json" },
        JSON.stringify({ products })
      )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.error("Error importing Alibaba products as drafts:", err);
          reject(err);
        });
    });
  }

  /**
   * Import selected Alibaba products as completed (status=5)
   * @param {Array} products - Array of Alibaba product objects
   * @returns {Promise} API response
   */
  static importProductsAsCompleted(products) {
    return new Promise((resolve, reject) => {
      callAPI(
        process.env.REACT_APP_APIUrl + NetworkConfiguration.IMPORT_ALIBABA_RAW,
        "POST",
        { "Content-Type": "application/json" },
        JSON.stringify({ products })
      )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.error("Error importing Alibaba products as completed:", err);
          reject(err);
        });
    });
  }
}

export default AlibabaAdminService;
